<template>
    <a
        v-if="thumbUrl"
        class="student-work-item"
        @click="showModal"
        href="javascript:;"
    >
        <transition appear name="fade" mode="out-in">
            <img
                class="student-work-item__image"
                :src="thumbUrl"
                :key="thumbUrl"
                :alt="title"
                :height="340"
                :width="380"
            />
        </transition>
    </a>
</template>

<script>
import { EventBus } from "../event-bus.js";

export default {
    name: "StudentWorkItem",

    props: {
        work: Object,
    },

    computed: {
        imageUrl() {
            return this.work.image;
        },

        title() {
            return this.work.title;
        },

        thumbUrl() {
            return this.work.thumb;
        },

        modalContents() {
            return this.work;
        },
    },

    methods: {
        showModal() {
            EventBus.$emit("open-global-modal", this.modalContents);
        },
    },
};
</script>
